import React from 'react';
import Layout from '../components/common/Layout';
import {
    Boxes,
    DollarSign,
    FolderOpen,
    Truck,
    Leaf,
    Construction,
    Clock,
} from 'lucide-react';

// Mapa de íconos por módulo (mismo string que guarda la BD en menu_items.icono).
const ICONOS = {
    Boxes,
    DollarSign,
    FolderOpen,
    Truck,
    Leaf,
};

/**
 * Página placeholder para módulos que aún están en desarrollo.
 * Se reutiliza desde App.jsx pasando `titulo`, `descripcion` e `icono`.
 */
const ComingSoonPage = ({ titulo = 'Módulo', descripcion = '', icono = 'Construction' }) => {
    const Icon = ICONOS[icono] || Construction;

    return (
        <Layout>
            <div className="p-6">
                {/* Header */}
                <div className="mb-8">
                    <h1 className="text-2xl font-bold text-gray-900">{titulo}</h1>
                    {descripcion && (
                        <p className="text-gray-500 text-sm mt-1">{descripcion}</p>
                    )}
                </div>

                {/* Tarjeta "en proceso" */}
                <div className="flex items-center justify-center">
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 max-w-lg w-full px-8 py-12 text-center">
                        <div className="mx-auto w-20 h-20 rounded-2xl bg-blue-50 flex items-center justify-center mb-6">
                            <Icon className="h-10 w-10 text-blue-600" />
                        </div>

                        <span className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-800 text-xs font-semibold px-3 py-1 rounded-full mb-4">
                            <Clock className="h-3.5 w-3.5" />
                            En proceso
                        </span>

                        <h2 className="text-xl font-bold text-gray-900 mb-2">
                            {titulo}
                        </h2>
                        <p className="text-gray-500 text-sm leading-relaxed">
                            Estamos trabajando en esta sección.
                            <br />
                            La habilitaremos muy pronto. 🚧
                        </p>

                        <div className="mt-6 flex items-center justify-center text-gray-400 text-xs">
                            <Construction className="h-4 w-4 mr-1.5" />
                            Módulo en construcción
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ComingSoonPage;
